import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export default function useFetch(path, deps = []) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        if (!path) return;
        setLoading(true);
        try {
            const res = await api.get(path);
            setData(res.data);
            setError(null);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [path]);

    useEffect(() => { load(); }, deps); // eslint-disable-line

    return { data, loading, error, reload: load, setData };
}
